module.exports = __webpack_public_path__ + "static/media/fortune.48899569.png";